export default "__VITE_ASSET__BiZ$dL2c__"